import React, { useMemo } from 'react';
import GamUprTabConfig from './GamUprTabConfig';
import constants from '../constants.json';
//mui imports====
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';

const GamUprOsConfig = ({ keyData, platform }) => {
	const { gamUprOperatingSystems } = constants;

	const tabListAndPanels = useMemo(() => {
		if (!keyData) {
			return [];
		}
		const osList = gamUprOperatingSystems[platform] || [];
		return osList.map((operatingSystem) => {
			return {
				tab: <Tab key={operatingSystem} label={operatingSystem} value={operatingSystem} />,
				tabPanel: (
					<TabPanel value={operatingSystem}>
						<GamUprTabConfig
							keyData={keyData}
							platform={platform}
							operatingSystem={operatingSystem}
						/>
					</TabPanel>
				)
			};
		});
	}, [keyData, platform]);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}}
		>
			<GeneralTab
				tabListProps={{
					variant: 'fullWidth'
				}}
				tabListAndPanels={tabListAndPanels}
				tabListStyles={{ width: '55rem', marginLeft: '3rem' }}
			/>
		</Box>
	);
};

export default GamUprOsConfig;
